import React from "react";
import PropTypes from "prop-types";
import { Paper, Typography, LinearProgress, Box } from "@mui/material";
import { Doughnut } from "react-chartjs-2";
import { CHART_COLORS } from "./chartTheme";
import { formatCurrency } from "./formatters";

// Donut chart card — order status distribution, payment methods, new vs returning customers.
const DoughnutChartCard = ({ title, labels = [], series = [], loading, height = 280, currency = false, colors }) => {
  const hasData = labels.length > 0 && series.length > 0;

  const data = {
    labels,
    datasets: [
      {
        data: series,
        backgroundColor: labels.map((_, index) => (colors ? colors[index] : CHART_COLORS[index % CHART_COLORS.length])),
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "right" },
      tooltip: currency
        ? {
            callbacks: {
              label: (context) => `${context.label}: ${formatCurrency(context.parsed)}`,
            },
          }
        : undefined,
    },
  };

  return (
    <Paper sx={{ padding: "1rem" }}>
      <Typography sx={{ fontSize: "16px", fontWeight: 700, marginBottom: "1rem" }}>
        {title}
      </Typography>
      {loading && <LinearProgress />}
      {!loading && !hasData && (
        <Typography sx={{ color: "#6B7280", fontSize: "13px", padding: "2rem 0", textAlign: "center" }}>
          No data available for this range.
        </Typography>
      )}
      {!loading && hasData && (
        <Box sx={{ height }}>
          <Doughnut options={options} data={data} />
        </Box>
      )}
    </Paper>
  );
};

DoughnutChartCard.propTypes = {
  title: PropTypes.string.isRequired,
  labels: PropTypes.array,
  series: PropTypes.array,
  loading: PropTypes.bool,
  height: PropTypes.number,
  currency: PropTypes.bool,
  colors: PropTypes.array,
};

export default DoughnutChartCard;
